import LineFilters from '../../generic/LineFilters';
import convertToOption from '../../utils/convert-to-option';
import getEventTargetValue from '../../utils/get-event-target-value';
import { applyFilters } from '../actions';
import { connectEditor } from '../connect-editor';
import {
  getAvailableFilterValues,
  getCategoryOptions,
  getProductOptions,
  QUOTE_FILTER_TYPES,
} from '../utils/filter-utils';

const mapStateToProps = (
  { quoteLinesById, quoteLineFilters },
  { allCategories, allProducts },
) => {
  const filterOptions = getAvailableFilterValues(quoteLinesById);

  function getOptionsFor(name) {
    if (name === 'categories') {
      return getCategoryOptions(filterOptions.categories, allCategories);
    }
    if (name === 'products') {
      return getProductOptions(filterOptions.productIds, allProducts);
    }
    return filterOptions[name].map(convertToOption);
  }

  return {
    filters: QUOTE_FILTER_TYPES.map(({ name }) => ({
      name,
      selected: quoteLineFilters[name],
      all: getOptionsFor(name),
    })),
  };
};

const mapDispatchToProps = dispatch => ({
  onChange: event =>
    dispatch(
      applyFilters(event.target.name, getEventTargetValue(event.target)),
    ),
});

export default connectEditor(mapStateToProps, mapDispatchToProps)(LineFilters);
